import { Quote, Star } from "lucide-react";

const TESTIMONIALS = [
  {
    name: "Calum Rob",
    role: "Director",
    quote:
      "Jordan doesn't talk theory — he talks execution. In a few months he helped me restructure how I run the business, and the results showed up in the bank. Worth every minute.",
  },
  {
    name: "Rafael Vaz Da Silva",
    role: "Portfolio Manager",
    quote:
      "The mentorship sharpened my thinking more than any course I've paid for. Jordan asks the questions that force you to actually move. I left every call with a clear next step.",
  },
  {
    name: "Teekay Films",
    role: "Videographer",
    quote:
      "Joining the Builder Programme gave me the structure I was missing. Content days at the FMF studio alone took my brand to a new level — but the community is what keeps you accountable.",
  },
  {
    name: "Gavin McAllister",
    role: "DWITS LTD",
    quote:
      "Jordan is one of the few people I trust to give me a straight answer. The 1:1 calls are gold — we worked through real growth problems and I came out with a clearer plan than I'd had in years.",
  },
];

export const Testimonials = () => {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative bg-[#050505] py-24 md:py-40 border-t border-zinc-900"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16 md:mb-20">
          <div className="md:col-span-7">
            <div className="reveal flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-zinc-600" />
              <span className="text-xs tracking-[0.3em] uppercase text-zinc-400 font-bold">
                Words From Builders
              </span>
            </div>
            <h2
              data-testid="testimonials-headline"
              className="reveal text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-extrabold text-white leading-[1.02]"
            >
              People who chose to{" "}
              <span className="italic font-light text-white">
                invest in themselves.
              </span>
            </h2>
          </div>
          <div className="md:col-span-5 flex md:items-end">
            <p className="reveal text-base md:text-lg leading-relaxed text-zinc-400 font-medium">
              Real founders, operators and creators inside The Builder
              Programme — sharing what changed when they stopped overthinking
              and started executing.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-zinc-900 border border-zinc-900">
          {TESTIMONIALS.map((t, i) => (
            <figure
              key={i}
              data-testid={`testimonial-card-${i + 1}`}
              className="reveal group bg-[#0A0A0A] hover:bg-[#0F0F0F] transition-colors duration-500 p-8 md:p-12 flex flex-col"
            >
              <Quote
                className="w-7 h-7 text-zinc-600 group-hover:text-[#EDE6D5] transition-colors duration-300 mb-8"
                strokeWidth={1.3}
              />
              <blockquote className="text-lg md:text-xl leading-relaxed text-zinc-200 font-medium mb-10 max-w-xl">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-auto flex items-end justify-between border-t border-zinc-900 pt-5 gap-4">
                <div>
                  <div className="flex items-center gap-1 mb-2" data-testid={`testimonial-stars-${i + 1}`}>
                    {Array.from({ length: 5 }).map((_, s) => (
                      <Star
                        key={s}
                        className="w-3.5 h-3.5 text-white fill-white"
                        strokeWidth={1.2}
                      />
                    ))}
                  </div>
                  <div className="text-white font-bold tracking-tight">
                    {t.name}
                  </div>
                  <div className="text-xs tracking-[0.25em] uppercase text-zinc-500 font-bold mt-1">
                    {t.role}
                  </div>
                </div>
                <span className="text-[10px] tracking-[0.3em] uppercase text-zinc-700 font-bold">
                  0{i + 1} / 0{TESTIMONIALS.length}
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};
